module.exports = __webpack_public_path__ + "img/project1_small@2x.11b36ca3.jpg";